var render, staticRenderFns
import script from "./overview_of_cooperation_item.vue?vue&type=script&lang=js"
export * from "./overview_of_cooperation_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('955bf50c')) {
      api.createRecord('955bf50c', component.options)
    } else {
      api.reload('955bf50c', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/customer_information/components/overview_of_cooperation/overview_of_cooperation_item.vue"
export default component.exports